/* eslint-disable @atlassian/tangerine/import/no-parent-imports */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl-next';

import { cssMap, jsx } from '@atlaskit/css';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { ScreenLayout } from '../../../twc-xflow-modal/components/screen-layout';
import { messages } from '../welcome-content/messages';

export type WelcomeModalProps = {
	Animation: React.ReactNode;
	Content: React.ReactNode;
	isOpen: boolean;
	onClose: () => void;
	testId?: string;
};

const styles = cssMap({
	modalWrapper: {
		position: 'relative',
		width: '100%',
		overflow: 'hidden',
		maxWidth: '968px',
		minHeight: '568px',
	},
	contentWrapper: {
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
	},
});

export const WelcomeModal = ({
	isOpen,
	onClose,
	testId,
	Animation,
	Content,
}: WelcomeModalProps): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<ModalTransition>
			{isOpen && (
			<Modal
				onClose={onClose}
				testId={testId}
				shouldCloseOnOverlayClick
				shouldCloseOnEscapePress
				width="x-large"
				label={formatMessage(messages.title)}
			>
					<Box xcss={styles.modalWrapper}>
						<ScreenLayout>
							<ScreenLayout.Background>{Animation}</ScreenLayout.Background>
							<ScreenLayout.Content>
								<Box xcss={styles.contentWrapper}>{Content}</Box>
							</ScreenLayout.Content>
						</ScreenLayout>
					</Box>
				</Modal>
			)}
		</ModalTransition>
	);
};
